import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import moment from 'moment';
import AdminTableComponent from '../admin-table'
import { getBookings } from '../actions';
import { Link } from 'react-router-dom';

const shortDateFormat = "MM/DD/YY";
const longDateFormat = "MM/DD/YY hh:mm:ss";

function formatAsCurrency(value) {
  return isNaN(value) ? null : (value).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
}
const mapStateToProps = state => ({
  global: state.Global,
  bookings: state.Admin.bookings
});
const columns =
  [
    {
      Header: "Booking ID",
      accessor: "_id",
      disableSortBy: true,
      Cell: ({ cell: { value } }) => { return <Link to={`/admin/bookings/${value}`}>{value}</Link> }
    },
    {
      Header: "Created\nDate",
      accessor: "rawCreatedDate",
      Cell: ({ data: booking }) => booking.niceCreatedDate,
      CustomData: true
    },
    {
      Header: "Start\nDate",
      accessor: "rawStartDate",
      Cell: ({ data: booking }) => booking.niceStartDate,
      CustomData: true
    },
    {
      Header: "End\nDate",
      accessor: "rawEndDate",
      Cell: ({ data: booking }) => booking.niceEndDate,
      CustomData: true
    },
    {
      Header: "Renter",
      accessor: "fullRenterAccessor",
      Cell: ({ data: booking }) => booking.fullRenterName,
      CustomData: true
    },
    {
      Header: "Owner",
      accessor: "fullOwnerAccessor",
      Cell: ({ data: booking }) => booking.fullOwnerName,
      CustomData: true
    },
    {
      Header: "Listing",
      accessor: "listingId.listingName",
      Cell: ({ cell: { value }, data: booking }) => { return <Link to={`/listing/${booking.listingId._id}`}>{value}</Link> },
      CustomData: true
    },
    {
      Header: "Location",
      accessor: "fullAddress",
    },
    {
      Header: "Request\nStatus",
      accessor: "niceRequestStatus",
    },
    {
      Header: "Request\nStatus\nUpdated\nRequest",
      accessor: "rawRequestUpdatedDate",
      Cell: ({ data: booking }) => booking.niceRequestUpdatedDate,
      CustomData: true
    },
    {
      Header: "Payment\nStatus",
      accessor: "nicePaymentStatus"
    },
    {
      Header: "Payment\nStatus\nUpdated\nDate",
      accessor: "rawPaymentUpdatedDate",
      Cell: ({ data: booking }) => booking.nicePaymentUpdatedDate,
      CustomData: true
    },
    {
      Header: "Total\nAmount",
      accessor: "total",
      Cell: ({ cell: { value } }) => { return `$ ${formatAsCurrency(value)}` }
    },
  ];

export const compare = (propertyA, propertyB, dataType) => {
  const retVal = dataType === 'string' ? 1 : -1;
  if (propertyA > propertyB) return retVal;
  else if (propertyA < propertyB) return -retVal;
  else return 0;
}

export const getOrder = (propertyA, propertyB, currentSort, dataType) => {
  if (propertyA && propertyB) {
    if (currentSort === 'desc')
      return compare(propertyA, propertyB, dataType);
    else if (currentSort === 'asc')
      return compare(propertyB, propertyA, dataType);
    else
      return compare(propertyA, propertyB, null);
  }

  if (propertyA && !propertyB) {
    return currentSort === 'asc' ? 1 : -1;
  }

  if (!propertyA && propertyB) {
    return currentSort === 'desc' ? 1 : -1;
  }

  return 0;
}
class BookingsListComponent extends PureComponent {
  constructor(props) {
    super(props);
  }

  state = {
    currentSort: 'desc',
    columnSorted: 'createdDate',
    dataType: 'date',
  };

  componentDidMount() {
    let { dispatch } = this.props;
    dispatch(getBookings());
  }

  compareBookings = (a, b) => {
    let { columnSorted, currentSort, dataType } = this.state;
    let dotCount = columnSorted.split(".").length - 1;

    // no periods between properties
    if (dotCount === 0) {
      let propertyA = a[columnSorted], propertyB = b[columnSorted];
      return getOrder(propertyA, propertyB, currentSort, dataType);
    }
    // 1 period between properties
    else if (dotCount === 1) {
      let str1 = columnSorted.substring(0, columnSorted.indexOf('.'));
      let str2 = columnSorted.substring(columnSorted.indexOf('.') + 1);
      let propertyA = a[str1][str2], propertyB = b[str1][str2];
      return getOrder(propertyA, propertyB, currentSort, dataType);
    }
    // 2 periods between properties
    else if (dotCount === 2) {
      let str1 = columnSorted.substring(0, columnSorted.indexOf('.'));
      let str2 = columnSorted.substring(columnSorted.indexOf('.') + 1, columnSorted.lastIndexOf('.'));
      let str3 = columnSorted.substring(columnSorted.lastIndexOf('.') + 1);
      let propertyA = a[str1][str2][str3], propertyB = b[str1][str2][str3];
      return getOrder(propertyA, propertyB, currentSort, dataType);
    }
    return 0;
  }

  onSort = (column, type) => {
    const { currentSort, columnSorted } = this.state;
    let nextSort;

    if (column === columnSorted) {
      if (currentSort === 'desc')
        nextSort = 'asc';
      else if (currentSort === 'asc')
        nextSort = 'desc';
      else if (currentSort === 'default')
        nextSort = 'desc';
      else nextSort = 'default';
    }
    else nextSort = 'desc';

    this.setState({ currentSort: nextSort, columnSorted: column, dataType: type });
  }

  mapPartA = (b) => {
    b['rawCreatedDate'] = moment(b.createdDate).valueOf();
    b['niceCreatedDate'] = moment(b.createdDate).format(shortDateFormat);
    b['rawStartDate'] = moment(b.startDate).valueOf();
    b['niceStartDate'] = moment(b.startDate).format(shortDateFormat);
    b['rawEndDate'] = moment(b.endDate).valueOf();
    b['niceEndDate'] = moment(b.endDate).format(shortDateFormat);
    b['fullRenterAccessor'] = `${b.userId.lastName} ${b.userId.firstName}`;
    b['fullRenterName'] = `${b.userId.firstName} ${b.userId.lastName}`;
    b['fullOwnerAccessor'] = b.listingId.userId ? `${b.listingId.userId.lastName} ${b.listingId.userId.firstName}` : ''
    b['fullOwnerName'] = b.listingId.userId ? `${b.listingId.userId.firstName} ${b.listingId.userId.lastName}` : ''

    b.rawPaymentUpdatedDate = b.paymentStatusUpdatedDate ? moment(b.paymentStatusUpdatedDate).valueOf() : 0
    b.nicePaymentUpdatedDate = b.paymentStatusUpdatedDate !== undefined ? moment(b.paymentStatusUpdatedDate).format(longDateFormat) : "N/A";
  }

  mapPartB = b => {
    let currentDateTime = new Date();

    let bookingExpirationDate = new Date(b.expiration);
    let bookingStartDate = new Date(b.startDate);

    let niceRequestStatus = b.bookingRequestStatus;
    if ((b.bookingRequestStatus === "Pending")
      && (currentDateTime >= bookingExpirationDate || currentDateTime >= bookingStartDate))
      niceRequestStatus = "Expired";

    let nicePaymentStatus = b.bookingPaymentStatus;
    if ((b.bookingPaymentStatus === "Pending")
      && (currentDateTime >= bookingExpirationDate || currentDateTime >= bookingStartDate))
      nicePaymentStatus = "Expired";

    b.fullAddress = b.listingId.address ? `${b.listingId.address.city}, ${b.listingId.address.state}` : "N/A";
    b.niceRequestStatus = niceRequestStatus;
    b.rawRequestUpdatedDate = b.requestStatusUpdatedDate ? moment(b.requestStatusUpdatedDate).valueOf() : 0;
    b.niceRequestUpdatedDate = b.requestStatusUpdatedDate !== undefined ? moment(b.requestStatusUpdatedDate).format(longDateFormat) : "N/A";
    b.nicePaymentStatus = nicePaymentStatus;
  }

  render() {
    let { bookings } = this.props;

    let orderedBookings = bookings.map(b => {
      this.mapPartA(b);
      this.mapPartB(b);
      return b;
    }).sort(this.compareBookings);

    if (!bookings)
      return (<div className="container text-center"><h4>Loading...</h4></div>)

    return (
      <AdminTableComponent columns={columns} data={orderedBookings} />
    );
  }
}

export default withRouter(connect(mapStateToProps)(BookingsListComponent));
